import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { IGameCategoriesContext, GameCategoriesContext } from '../../gameCategoriesState/gameCategoriesContext';
import Item from './components/Item';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import classNames from 'classnames';
import style from './GameCategories.module.scss';

const GameCategories: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, gameCategories, currentPage, countOfItems } =
		useContext<IGameCategoriesContext>(GameCategoriesContext);
	const categoriesHeadingClasses = classNames(style.categories, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<>
			{gameCategories.gameCategoriesCount ? (
				<div className={style.container} data-test="GameCategories">
					<div className={style.tableHeaders}>
						<Text
							className={categoriesHeadingClasses}
							translationNameSpace="listing"
							translationKey="categoriesLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<Text
							className={actionHeadingClasses}
							translationNameSpace="listing"
							translationKey="actionLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
					</div>
					{gameCategories.gameCategories.map((item, index) => (
						<Item data={item} key={item.id} index={index} />
					))}
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={gameCategories.gameCategoriesCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default GameCategories;
